import React from 'react';

function Pennant({ size = 14, color = 'var(--crimson)' }) {
  return (
    <span
      className="pennant"
      style={{ width: size, height: size * 1.3, background: color }}
    />
  );
}

export default Pennant;
